/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import SvgMap from '../maps';

const CustomMap = ({
  allRegions,
  allMap,
  currentCommunity,
  electionNumber,
  excludedGrandParentIds,
  isFiltered,
  maps,
  mouseChange,
  native,
  onChange,
  partiesWinners,
  placeId,
  selectedPlace,
  showDifference = true,
  showDots = false,
  showTooltipInfo,
  site,
  type,
  year
}) => (
  <div className="mapWrapper">
    <SvgMap
      allRegions={isFiltered ? [] : allRegions}
      allMap={allMap}
      className="mapa-svg"
      currentCommunity={currentCommunity}
      electionNumber={electionNumber}
      electionType={type}
      excludedGrandParentIds={excludedGrandParentIds}
      mapElements={maps}
      mouseChange={mouseChange}
      native={native}
      // eslint-disable-next-line consistent-return
      onClick={(item, svgEl, event) => {
        if (showDots) {
          return onChange(event, item);
        }
        onChange(event, item);
      }}
      partiesWinners={partiesWinners}
      placeId={placeId}
      selectedPlace={selectedPlace}
      showDifference={showDifference}
      showDots={showDots}
      showTooltipInfo={showTooltipInfo}
      site={site}
      year={year}
    />
  </div>
);

CustomMap.propTypes = {
  maps: PropTypes.arrayOf(
    PropTypes.shape({
      ineId: PropTypes.string,
      main: PropTypes.bool,
      name: PropTypes.string,
      parentId: PropTypes.string,
      svg: PropTypes.string,
      typePlace: PropTypes.string
    })
  )
};

CustomMap.defaultProps = {
  maps: null
};

export default CustomMap;
